import { ModalSidePanel, useDeleteConfirmationDialog } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { IconButton, IconName, Typography } from '@optimus-web/core';
import { useDeleteLocalProduct, useGetLocalProductDetail } from '../../queries/LocalProductsTable';
import { LocalProductSidePanelTabs } from './LocalProductSidePanelTabs';

interface Props {
    localProductId: string;
    propertyName: string;
    productName: string;
    propertyId: string;
    onClose: () => void;
}

export const LocalProductSidePanel = ({ onClose, localProductId, propertyName, productName, propertyId }: Props) => {
    const { data, isFetching } = useGetLocalProductDetail(localProductId);
    const { mutateAsync, isPending } = useDeleteLocalProduct();

    const deleteAction = async () => {
        await mutateAsync({ enterpriseProductIds: [localProductId] });
        onClose();
    };

    const assignedPropertyCount = data?.services.length || 0;

    const { confirmationDialog, openConfirmationDialog } = useDeleteConfirmationDialog({
        deleteAction,
        renderContent: () => (
            <Typography textStyle="bodyMedium" as="div">
                {lt('EnterpriseProductDeleteDialogContent', { assignedPropertyCount })}
            </Typography>
        ),
        title: lt('EnterpriseProductDeleteDialogTitle'),
        loading: isPending,
    });

    return (
        <>
            <ModalSidePanel
                width="medium"
                opened
                loading={isFetching}
                title={
                    <Typography textStyle="titleMediumStrong" as="div">
                        {productName}
                    </Typography>
                }
                subtitle={
                    <Typography textStyle="bodySmall" variant="tertiary" as="div">
                        {propertyName}
                    </Typography>
                }
                onClose={onClose}
                content={data ? <LocalProductSidePanelTabs {...data} propertyId={propertyId} /> : null}
                headerActions={
                    <IconButton type="button" icon={IconName.Delete} onClick={openConfirmationDialog} size="small" />
                }
            />
            {confirmationDialog}
        </>
    );
};
